module.exports = __webpack_public_path__ + "media/icons/skrzynia-automatyczna-blue@3x-d246c22f.svg";